var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.pages),function(page){return _c('div',{key:'page' + page.id,class:{
            'mt-2': page.page != '1'
        }},[_c('Page',{attrs:{"publication_id":_vm.publication_id,"publication":_vm.publication,"unit_group":_vm.unit_group,"unit":_vm.unit,"page":page,"disabled":_vm.disabled,"available_standards":_vm.available_standards,"state_grade":_vm.state_grade}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }